"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromise = exports.isNil = exports.clamp = exports.range = exports.some = exports.merge = exports.isEqual = exports.isEmpty = exports.debounce = void 0;
var debounce_1 = __importDefault(require("lodash/debounce"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var merge_1 = __importDefault(require("lodash/merge"));
var some_1 = __importDefault(require("lodash/some"));
var range_1 = __importDefault(require("lodash/range"));
var clamp_1 = __importDefault(require("lodash/clamp"));
var isNil_1 = __importDefault(require("lodash/isNil"));
__exportStar(require("./array"), exports);
__exportStar(require("./Observable"), exports);
__exportStar(require("./types"), exports);
exports.debounce = debounce_1.default;
exports.isEmpty = isEmpty_1.default;
exports.isEqual = isEqual_1.default;
exports.merge = merge_1.default;
exports.some = some_1.default;
exports.range = range_1.default;
exports.clamp = clamp_1.default;
exports.isNil = isNil_1.default;
/**
 * Check whether the object is a promise.
 */
exports.isPromise = function (obj) {
    return obj && typeof obj.then === 'function';
};
//# sourceMappingURL=index.js.map